import React, { useState } from 'react';
import Chevron from 'components/Chevron';
import s from './PlayFreeMoreInfoLink.module.css';

const PlayFreeMoreInfoLink = ({ title, expandedContent }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div className={s.heading} onClick={() => setExpanded(!expanded)} style={{ display: 'flex' }}>
        {title}
        {expandedContent && (
          <Chevron
            direction="down"
            reversed={expanded}
            style={{ marginLeft: '0.5em', fontSize: '1.2em' }}
          />
        )}
      </div>

      {expanded && expandedContent}
    </>
  );
};

export default PlayFreeMoreInfoLink;
